import { render, staticRenderFns } from "./otherContract.vue?vue&type=template&id=7fe8962c&scoped=true"
import script from "./otherContract.vue?vue&type=script&lang=js"
export * from "./otherContract.vue?vue&type=script&lang=js"
import style0 from "./otherContract.vue?vue&type=style&index=0&id=7fe8962c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe8962c",
  null
  
)

export default component.exports